module.exports = __webpack_public_path__ + "static/11-3f8b9e705d4dde51177ef44b34eb8ffa.jpg";